/*
 * Part of the RubinRed CMS.
 * @author    Marco Tisi <tisi@workup.it>
 * @license   Proprietary
 * @copyright 2015-2018, Workup Srl
 * @link      http://rubinred.com
 */

import Vue from 'vue';

/**
 * Components which will not be loaded.
 * @type {Array}
 */
const blacklist = [
  // 'ExampleComponent'
];

const contexts = [
  require.context('../../../../uikit3/assets/js/theme-components/', true, /\.vue$/i),
  require.context('../../../../uikit3/extensions/', true, /\.vue$/i),
  require.context('../../../../uikit3/assets/js/components/', true, /\.vue$/i),
  require.context('js/theme-components/', true, /\.vue$/i),
  require.context('../../../extensions/', true, /\.vue$/i),
  //require.context('js/components/', true, /\.vue$/i),
];

contexts.forEach(context => context.keys().filter(key => !blacklist.includes(key.split('/').pop().split('.')[0])).map(key => Vue.component(key.split('/').pop().split('.')[0], context(key))));

export default Vue;



// WEBPACK FOOTER //
// ./public/themes/frontend/mtg/assets/js/vendor/vue.js